export const title2 = [{name:' TOP EMPLOYEES'}]
export const heading =[
    {heading:'Full Name'},
    {heading:'Department'},
    {heading:'Project Finished'}
]
export const data =[
    {fname:'Eilena' , profession:'Content Writer' ,status:'Interview'},
    {fname:'Milke Tayler' , profession:'Content Writer' ,status:'Resume'},
    {fname:'Rose gilbert' , profession:'Content Writer' ,status:'Resume'},
]